import React, { useEffect, useState } from "react";
import { WithdrawIcon } from "../SvgIcons/SvgIcons";
import { Checkbox, Spin } from "antd";
import {
  GET_BANK_ACCOUNTS,
  GET_ACCOUNTS,
} from "../../../graphql/query/accounts";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { WITHDRAW_REQUEST } from "../../../graphql/mutations/accounts";
import Withdraw from "../../../imgs/Withdraw.svg";
import { useSelector } from "react-redux";
import { ADD_BANK_ACCOUNTS } from "../../../graphql/mutations/accounts";

const PostBounty = ({ handleCancel }) => {
  const [account] = useState([]);
  const [bankName, setBankName] = useState("");
  const [accountName, setAccountName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [bankAddress, setBankAddress] = useState("");
  const [swiftCode, setSwiftCode] = useState("");
  const [cardData, setCardData] = useState([]);
  const [accountId, setAccountId] = useState("");
  const [loader, setLoader] = useState(false);
  const [withdraw, setWithdraw] = useState(false);
  const [addWithdraw, setAddWithdraw] = useState(false);
  const [withdrawPage, setWithdrawPage] = useState(true);
  const [withdrawAmount, setWithdrawAmount] = useState("");
  const [hideBank, sethideBank] = useState(true);
  const [withdrawAccount, setWithdrawAccount] = useState(false);

  const userProfile = useSelector((state) => state.strapiRes);

  const [getBankAccount] = useLazyQuery(gql(GET_BANK_ACCOUNTS), {
    fetchPolicy: "cache-and-network",
    onCompleted: ({ accounts }) => setCardData(accounts),
  });

  const [addBankAccount] = useMutation(gql(ADD_BANK_ACCOUNTS));

  const [getAccounts] = useLazyQuery(gql(GET_ACCOUNTS), {
    fetchPolicy: "cache-and-network",
    onCompleted: ({ accounts }) => {
      setBankName(accounts[0].bankName);
      setAccountName(accounts[0].accountName);
      setAccountNumber(accounts[0].accountNumber);
      setBankAddress(accounts[0].address);
      setSwiftCode(accounts[0].swiftCode);
    },
  });

  const newBank = () => {
    setWithdrawPage(false);
    setAddWithdraw(true);
    setWithdrawAccount(!withdrawAccount);
    sethideBank(!hideBank);
  };

  const [addWithdrawAmount] = useMutation(gql(WITHDRAW_REQUEST));

  const handleWithdrawAmount = () => {
    if (withdrawAmount && withdraw) {
      setLoader(true);
      addWithdrawAmount({
        variables: {
          amount: parseInt(withdrawAmount),
          accountId: accountId,
          profileId: userProfile?.id,
        },
      }).then(() => {
        setLoader(false);
        setWithdrawPage(false);
        next();
      });
    }
  };

  const handleAddAccount = () => {
    if (bankName && accountName && accountNumber && bankAddress && swiftCode) {
      setLoader(true);
      addBankAccount({
        variables: {
          profileId: userProfile?.id,
          bankName: bankName,
          accountName: accountName,
          accountNumber: accountNumber,
          address: bankAddress,
          swiftCode: swiftCode,
        },
      }).then((res) => {
        setLoader(false);
        setBankName("");
        setAccountName("");
        setAccountNumber("");
        setBankAddress("");
        setSwiftCode("");
        setWithdrawPage(true);
        sethideBank(true);
        setWithdrawAccount(false);
        setAddWithdraw(false);
      });
    }
  };

  const handleAddWithdraw = () => {
    setWithdrawPage(true);
    sethideBank(true);
    setAddWithdraw(false);
  };

  const Done = () => {
    handleCancel();
    setWithdrawPage(true);
    sethideBank(true);
    setCurrent(0);
  };

  useEffect(() => {
    getBankAccount({
      variables: {
        profileId: userProfile?.id,
        start: 0,
        limit: 10,
      },
    });
  }, []);

  useEffect(() => {
    getAccounts({
      variables: {
        accountId: accountId,
      },
    });
  }, [accountId]);

  const steps = [
    {
      content: (
        <Spin className="loading" spinning={loader}>
          <div className="purchase-intro-modal add-funds-modal withdraw-funds-modal">
            <div className="modal-card-top">
              <div>
                <h2 className="heading">Withdraw funds</h2>
              </div>
              <WithdrawIcon />
            </div>
            <div className="funds-amount">
              <div className="checkbox-funds">
                <Checkbox>
                  <h2 className="small-heading">$1200</h2>
                </Checkbox>
              </div>
              <div className="input-field">
                <span className="icon" style={{ top: "11px" }}>
                  $
                </span>
                <input
                  type="text"
                  placeholder="Enter amount to withdraw"
                  value={withdrawAmount}
                  onChange={(event) => setWithdrawAmount(event.target.value)}
                />
              </div>
            </div>
            <div>
              <label>Withdraw method</label>
              {hideBank ? (
                <>
                  {cardData.map((value) => {
                    return (
                      <div
                        className="checkbox-container"
                        onClick={() => {
                          setAccountId(value.id);
                          setWithdraw(true);
                        }}
                      >
                        <Checkbox checked>
                          <p>
                            Bank account ending{" "}
                            {value.accountNumber.slice(
                              value.accountNumber.length - 4
                            )}
                          </p>
                        </Checkbox>
                      </div>
                    );
                  })}
                </>
              ) : (
                <></>
              )}
              {withdrawAccount ? (
                <div className="checkbox-container mb-2">
                  <Checkbox checked>
                    <p>Add new bank account</p>
                  </Checkbox>
                </div>
              ) : (
                <div className="checkbox-container">
                  <div
                    className="ant-checkbox-wrapper ant-checkbox-wrapper-checked AddIcon"
                    onClick={newBank}
                  >
                    <span className="ant-checkbox ant-checkbox-checked ant-checkbox-inner add">
                      +
                    </span>
                    <p className="pl-2">Add new bank account</p>
                  </div>
                </div>
              )}
              {withdrawPage ? (
                ""
              ) : (
                <div className="add-card-info">
                  <div className="input-field">
                    <label>Bank name</label>
                    <input
                      type="text"
                      placeholder={account.bankName}
                      disabled={withdraw ? true : false}
                      placeholder="Bank Of America"
                      name="bankName"
                      value={bankName}
                      onChange={(event) => setBankName(event.target.value)}
                    />
                  </div>
                  <div className="input-field">
                    <label>Bank account name</label>
                    <input
                      type="text"
                      placeholder="Tim Smith"
                      disabled={withdraw ? true : false}
                      name="bankAccountName"
                      value={accountName}
                      onChange={(event) => setAccountName(event.target.value)}
                    />
                  </div>
                  <div className="input-field">
                    <label>Bank account number</label>
                    <input
                      type="text"
                      placeholder="1665 4488 4545 1213"
                      disabled={withdraw ? true : false}
                      name="bankAccountNumber"
                      value={accountNumber}
                      onChange={(event) => setAccountNumber(event.target.value)}
                    />
                  </div>
                  <div className="input-field">
                    <label>Bank address</label>
                    <input
                      type="text"
                      placeholder="2972 Westheimer Rd. Santa Ana, Illinois 85486 "
                      name="bankAddress"
                      disabled={withdraw ? true : false}
                      value={bankAddress}
                      onChange={(event) => setBankAddress(event.target.value)}
                    />
                  </div>
                  <div className="row m-0">
                    <div className="input-field col-4 pl-0">
                      <label>Swift Code</label>
                      <input
                        type="text"
                        placeholder="BOFAUS3N"
                        name="swiftCode"
                        disabled={withdraw ? true : false}
                        value={swiftCode}
                        onChange={(event) => setSwiftCode(event.target.value)}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            <p className="policy-text">
              Please ensure your bank account information is accurate before
              proceeding. By continuing you are agreeing to our Terms of
              Service.
            </p>
            <div className="btn-row">
              {addWithdraw ? (
                <div className="col pl-0 ">
                  <button
                    className="btn-style cancel"
                    onClick={handleAddWithdraw}
                  >
                    Cancel
                  </button>
                </div>
              ) : (
                <div className="col pl-0 ">
                  <button className="btn-style cancel" onClick={handleCancel}>
                    Cancel
                  </button>
                </div>
              )}
              {addWithdraw ? (
                <div className="col p-0">
                  <button className="btn-style" onClick={handleAddAccount}>
                    Add Bank
                  </button>
                </div>
              ) : (
                <div className="col p-0">
                  <button className="btn-style" onClick={handleWithdrawAmount}>
                    Withdraw funds
                  </button>
                </div>
              )}
            </div>
          </div>
        </Spin>
      ),
    },
    {
      content: (
        <div className="bounty-modal-wrapper submit-wrapper">
          <div className="center-content">
            <img src={Withdraw} alt="Withdraw" className="icon" />
            <h2 className="heading">Withdraw request submitted</h2>
            <p>You have requested withdrawal of $1200.</p>
            <p className="sub-headings">
              PLease check your account in 3-5 few days after your withdrawal
              process is completed
            </p>
          </div>
          <button className="btn-style" onClick={Done}>
            Done
          </button>
        </div>
      ),
    },
  ];

  const [current, setCurrent] = useState(0);

  const next = () => {
    setCurrent(current + 1);
    setWithdrawAccount(false);
  };

  // const moveToDashBoard = () => {
  //   setCurrent(0);
  //   history.push('/home');
  // };

  return <div className="steps-content">{steps[current]?.content}</div>;
};

export default PostBounty;
